import React from 'react';
import BooksGallery from 'components/explore/BooksGallery';

export default function MayInterestYouBooks({ books }) {
  return <BooksGallery books={books} />;
}
